import { AdversetimentServerLoader } from '@/tracking/loader'
import type { IAd } from '@/types/ads'

export default function AdvertisementHook(props: {
  ads: IAd[]
}) {
  const ads = props.ads.flatMap((ad) =>
    ad.positions.map((t) => ({
      advertiser: ad.advertiser,
      target: ad.target,
      link: ad.link,
      tag: ad.tag,
      ...t,
    })),
  )

  AdversetimentServerLoader(ads)
}
